import { mapGetters } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import cepFieldComponent from "@/components/child/form/cepfield.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import cnpjComponent from "@/components/child/form/cnpj.vue";
import comboComponent from "@/components/child/form/combo.vue";
import cpfComponent from "@/components/child/form/cpf.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import textareaComponent from "@/components/child/form/textarea.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import infoBagdeComponent from "@/components/child/infoBagde/infoBagde.vue";
import logEntidadeComponent from "@/components/child/logEntidade/logEntidade.vue";
import UploadAnexoComponent from "@/components/child/uploadAnexo/uploadAnexo";
import uploadAnexoComponent from "@/components/child/uploadAnexo/uploadAnexo.vue";
import pacienteComponent from "@/components/parent/crud/paciente/edit.vue";
import InformacoesAdicionaisRepresentanteListComponent from "@/components/parent/informacoesAdicionaisRepresentante/list";
import informacoesAdicionaisRepresentanteListComponent from "@/components/parent/informacoesAdicionaisRepresentante/list.vue";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component, Prop, Watch } from "@/decorators";
import CepModel from "@/models/cepModel";
import ClienteEmailNotaFiscalModel from "@/models/clienteEmailNotaFiscalModel";
import ClienteEnderecoEntregaModel from "@/models/clienteEnderecoEntregaModel";
import ClienteModel from "@/models/clienteModel";
import ClienteTelefoneModel from "@/models/clienteTelefoneModel";
import ConfiguracaoFranquiaModel from "@/models/configuracaoFranquia/configuracaoFranquiaModel";
import AreaAtuacao from "@/models/enum/areaAtuacao";
import BeneficioFiscal from "@/models/enum/cliente/beneficioFiscal";
import IndicativoPresencialConsumidor from "@/models/enum/cliente/indicativoPresencialConsumidor";
import TipoMercado from "@/models/enum/cliente/tipoMercado";
import Configuracoes from "@/models/enum/configuracao/configuracoes";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import GenerosPessoa from "@/models/enum/generosPessoa";
import IndicadorOperacao from "@/models/enum/indicadorOperacao";
import OrgaoEmissaoCpfSNGPC from "@/models/enum/orgaoEmissaoCpfSNGPC";
import TipoCliente from "@/models/enum/tipoCliente";
import TiposPessoa from "@/models/enum/tiposPessoa";
import Ufs from "@/models/enum/ufs";
import PacienteModel from "@/models/paciente/pacienteModel";
import ClienteProdutoUsoEspecialModel from "@/models/produto/clienteProdutoUsoEspecialModel";
import beneficioService from "@/services/beneficioService";
import ClienteEnderecoEntregaService from "@/services/clienteEnderecoEntregaService";
import ClienteService from "@/services/clienteService";
import CidadeService from "@/services/external/cidadeService";
import naturezaOperacaoService from "@/services/naturezaOperacaoService";
import especieAnimalService from "@/services/paciente/especieAnimalService";
import PaisService from "@/services/paisService";
import PDFService from "@/services/pdf/PDFService";
import produtoService from "@/services/produto/produtoService";
import VendaService from "@/services/vendaService";
import { Getters } from "@/store/store";
import { copyObject } from "@/utils/common/copyObject";
import { editDateWithTime } from "@/utils/common/date";
import Delay from "@/utils/common/delay";
import { AcaoController, DescricaoTela } from "@/utils/common/permissionConstants";

import EditComponentBase from "../editComponentBase";
import PacienteComponent from "../paciente/edit";
import ReplicarSelecaoFranquiaFiliaisComponent from "../replicarSelecaoFranquiaFiliais/edit";
import replicarSelecaoFranquiaFiliaisComponent from "../replicarSelecaoFranquiaFiliais/edit.vue";

import EnderecoEntregaComponent from "./enderecoEntregaEdit";
import enderecoEntregaComponent from "./enderecoEntregaEdit.vue";
import VendasClienteListComponent from "./listVendas";
import vendasClienteListComponent from "./listVendas.vue";

import "../crud.scss";

@Component({
    components: {
        actionBarComponent,
        textareaComponent,
        fieldsetComponent,
        comboComponent,
        checkboxComponent,
        cpfComponent,
        cnpjComponent,
        cepFieldComponent,
        dateTimePickerComponent,
        logEntidadeComponent,
        dataTooltipComponent,
        pacienteComponent,
        gridComponent,
        enderecoEntregaComponent,
        buttonIncluirComponent,
        vendasClienteListComponent,
        infoBagdeComponent,
        shortcutComponent,
        uploadAnexoComponent,
        informacoesAdicionaisRepresentanteListComponent,
        replicarSelecaoFranquiaFiliaisComponent,
    },
    computed: {
        ...mapGetters([
            "VALIDAR_PERMISSAO_USUARIO",
            "GET_CONFIG_FRANQUIA",
            "GET_IS_ESTEREIS",
            "GET_IS_FRACIONAMENTO",
        ] as Getters),
        infoBagdeText() {
            return "Data criação: " + editDateWithTime(this.model.dataCriacao);
        },
    },
})
export default class ClienteEditComponent extends EditComponentBase<ClienteModel> {
    // State computed props
    VALIDAR_PERMISSAO_USUARIO!: (telaDescricao: string, acaoController: string) => boolean;
    GET_CONFIG_FRANQUIA!: (configuracao: Configuracoes) => ConfiguracaoFranquiaModel;
    GET_IS_ESTEREIS!: () => Promise<boolean>;
    GET_IS_FRACIONAMENTO!: () => Promise<boolean>;
    infoBagdeText!: string;

    private shortcutComponent: ShortcutComponent = null;
    private clienteService = new ClienteService();
    private clienteEnderecoEntregaService = new ClienteEnderecoEntregaService();
    private pdfService = new PDFService("ClientePDF");
    private cidadeService = new CidadeService();
    private vendaService = new VendaService();
    private pacienteComponent: PacienteComponent = null;
    private enderecoEntregaComponent: EnderecoEntregaComponent = null;
    private vendasClienteListComponent: VendasClienteListComponent = null;
    private uploadAnexoComponent: UploadAnexoComponent = null;
    private shortCutUploadUploadAnexoLote: ShortcutComponent = null;
    private informacoesAdicionaisRepresentanteListComponent: InformacoesAdicionaisRepresentanteListComponent = null;
    private replicarSelecaoFranquiaFiliaisComponent: ReplicarSelecaoFranquiaFiliaisComponent = null;

    private rotuloCarregado = false;
    private cpfObrigatorio = false;
    private emailNotaFiscalClienteObrigatorio = false;
    isFranquiaHumana = false;
    emailNotaFiscal = "";
    telefone = "";
    telefonePadrao = false;
    isGrupoAdmin = false;
    isEstereis = false;
    oldPaciente: PacienteModel = new PacienteModel();

    @Prop({ type: Boolean, default: false }) CalledByShortCut: boolean;

    private hideExtras = false;

    tiposPessoa = TiposPessoa;
    tiposPessoaOptions: Array<Object> = [
        { text: "F\u00edsica", value: TiposPessoa.Fisica },
        { text: "Jur\u00eddica", value: TiposPessoa.Juridica },
        { text: "Produtor Rural", value: TiposPessoa.ProdutorRural },
    ];

    tipoMercadoOptions: Array<Object> = [
        { text: "Prospect", value: TipoMercado.Prospect },
        { text: "Internacional", value: TipoMercado.internacional },
        { text: "Nacional", value: TipoMercado.nacional },
    ];

    tipoClienteOptions: Array<Object> = [
        { text: "Normal", value: TipoCliente.Normal },
        { text: "Franquia", value: TipoCliente.Franquia },
        { text: "Filial", value: TipoCliente.Filial },
        { text: "Própria empresa", value: TipoCliente.PropriaEmpresa },
    ];

    indicadorOperacaoOptions: Array<Object> = [
        { text: "0-Normal", value: IndicadorOperacao.Normal },
        { text: "1-Consumidor final", value: IndicadorOperacao.ConsumidorFinal },
    ];

    generosPessoaOptions: Array<Object> = [
        { text: "Masculino", value: GenerosPessoa.Masculino },
        { text: "Feminino", value: GenerosPessoa.Feminino },
    ];

    orgaoEmissaoCpfSNGPCOptions: Array<Object> = [
        { text: "CRA - CONSELHO REGIONAL DE ADMINISTRAÇÃO", value: OrgaoEmissaoCpfSNGPC.CRA },
        { text: "CRE - CONSELHO REGIONAL DE ECONOMIA", value: OrgaoEmissaoCpfSNGPC.CRE },
        { text: "CREA - CONSELHO REG.DE ENG. ARQUIT. E AGRONOMIA", value: OrgaoEmissaoCpfSNGPC.CREA },
        { text: "CRF - CONSELHO REGIONAL DE FARMÁCIA", value: OrgaoEmissaoCpfSNGPC.CRF },
        { text: "DGPC - DIRETORIA GERAL DA POLÍCIA CIVIL", value: OrgaoEmissaoCpfSNGPC.DGPC },
        { text: "DPF - DEPARTAMENTO DE POLÍCIA FEDERAL", value: OrgaoEmissaoCpfSNGPC.DPF },
        { text: "IDAMP - INSTITUTO IDENTIF. AROLDO MENDES PAIVA", value: OrgaoEmissaoCpfSNGPC.IDAMP },
        { text: "IFP - INSTITUTO FÉLIX PACHECO", value: OrgaoEmissaoCpfSNGPC.IFP },
        { text: "IN - IMPRENSA NACIONAL", value: OrgaoEmissaoCpfSNGPC.IN },
        { text: "JUNTA - JUNTA", value: OrgaoEmissaoCpfSNGPC.JUNTA },
        { text: "MAER - MINISTÉRIO DA AERONÁUTICA", value: OrgaoEmissaoCpfSNGPC.MAER },
        { text: "MEX - MINISTÉRIO DO EXÉRCITO", value: OrgaoEmissaoCpfSNGPC.MEX },
        { text: "MM - MINISTÉRIO DA MARINHA", value: OrgaoEmissaoCpfSNGPC.MM },
        { text: "OAB - ORDEM DOS ADVOGADOS DO BRASIL", value: OrgaoEmissaoCpfSNGPC.OAB },
        { text: "SEJSP - SECRETARIA DE EST. DA JUSTIÇA E SEG. PUB", value: OrgaoEmissaoCpfSNGPC.SEJSP },
        { text: "SES - SECRETARIA DE ESTADO DA SEGURANÇA", value: OrgaoEmissaoCpfSNGPC.SES },
        { text: "SESP - SECRETARIA DO ESTADO SEG. PÚBLICA", value: OrgaoEmissaoCpfSNGPC.SESP },
        { text: "SJS - SECRETARIA DA JUSTIÇA E DA SEGURANÇA", value: OrgaoEmissaoCpfSNGPC.SJS },
        { text: "SJTC - SECR. DA JUST. DO TRAB. E DA CIDADANIA", value: OrgaoEmissaoCpfSNGPC.SJTC },
        { text: "SSIPT - SECR.  DE SEG. E INFORM. POLÍCIA TÉCNICA", value: OrgaoEmissaoCpfSNGPC.SSIPT },
        { text: "SSP - SECRETARIA DE SEGURANÇA PÚBLICA", value: OrgaoEmissaoCpfSNGPC.SSP },
        { text: "VACIV - VARA CIVIL", value: OrgaoEmissaoCpfSNGPC.VACIV },
        { text: "VAMEN - VARA DE MENORES", value: OrgaoEmissaoCpfSNGPC.VAMEN },
        { text: "PM - POLICIA MILITAR", value: OrgaoEmissaoCpfSNGPC.PM },
        { text: "ITB - INSTITUTO TAVARES BURIL", value: OrgaoEmissaoCpfSNGPC.ITB },
        { text: "CRM - CONSELHO REGIONAL DE MEDICINA", value: OrgaoEmissaoCpfSNGPC.CRM },
        { text: "CBM - CORPO DE BOMBEIROS MILITAR", value: OrgaoEmissaoCpfSNGPC.CBM },
        { text: "DIC - DETRAN - DIRETORIA DE IDENTIFICAÇÃO CIVIL", value: OrgaoEmissaoCpfSNGPC.DIC },
        { text: "CFP - CONSELHO FEDERAL DE PSICOLOGIA", value: OrgaoEmissaoCpfSNGPC.CFP },
        { text: "CRO - CONSELHO REGIONAL DE ODONTOLOGIA", value: OrgaoEmissaoCpfSNGPC.CRO },
        { text: "COREN - CONSELHO REGIONAL DE ENFERMARIA", value: OrgaoEmissaoCpfSNGPC.COREN },
        { text: "CFN - CONSELHO FEDERAL DE NUTRICIONISTAS", value: OrgaoEmissaoCpfSNGPC.CFN },
        { text: "MRE - MINISTÉRIO DAS RELAÇÕES EXTERIORES", value: OrgaoEmissaoCpfSNGPC.MRE },
        { text: "CRCI - CONSELHO REG. DE CORRETORES DE IMÓVEIS", value: OrgaoEmissaoCpfSNGPC.CRCI },
        { text: "CRB - CONSELHO REGIONAL DE BIOLOGIA", value: OrgaoEmissaoCpfSNGPC.CRB },
        { text: "CRN - CONSELHO REGIONAL DE NUTRIÇÃO", value: OrgaoEmissaoCpfSNGPC.CRN },
        { text: "CFE - CONSELHO FEDERAL DE ENFERMAGEM", value: OrgaoEmissaoCpfSNGPC.CFE },
        { text: "CRC - CONSELHO REGIONAL DE CONTABILIDADE", value: OrgaoEmissaoCpfSNGPC.CRC },
        { text: "CRP - CONSELHO REGIONAL DE PSICOLOGIA", value: OrgaoEmissaoCpfSNGPC.CRP },
        { text: "CRQ - CONSELHO REGIONAL DE QUIMICA", value: OrgaoEmissaoCpfSNGPC.CRQ },
        { text: "ANVISA - AGÊNCIA NACIONAL DE VIGILÂNCIA SANITÁRIA", value: OrgaoEmissaoCpfSNGPC.ANVISA },
        { text: "GOVEST - GOVERNO DO ESTADO", value: OrgaoEmissaoCpfSNGPC.GOVEST },
        { text: "PREF - PREFEITURA", value: OrgaoEmissaoCpfSNGPC.PREF },
        { text: "CRBM - CONSELHO REGIONAL DE BIOMEDICINA", value: OrgaoEmissaoCpfSNGPC.CRBM },
        { text: "IPF - INSTITUTO PEREIRA FAUSTINO", value: OrgaoEmissaoCpfSNGPC.IPF },
        {
            text: "CREFITO - CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL",
            value: OrgaoEmissaoCpfSNGPC.CREFITO,
        },
        { text: "CRMV - CONSELHO REGIONAL DE MEDICINA VETERINÁRIA", value: OrgaoEmissaoCpfSNGPC.CRMV },
        { text: "MTE - MINISTÉRIO DO TRABALHO E EMPREGO", value: OrgaoEmissaoCpfSNGPC.MTE },
        { text: "CRFA - CONSELHO REGIONAL DE FONOAUDIOLOGIA", value: OrgaoEmissaoCpfSNGPC.CRFA },
        { text: "CORECON - CONSELHO REGIONAL DE ECONOMIA", value: OrgaoEmissaoCpfSNGPC.CORECON },
        { text: "SDS - SECRETARIA DE DESENVOLVIMENTO SOCIAL", value: OrgaoEmissaoCpfSNGPC.SDS },
        { text: "SRF - SECRETARIA DA RECEITA FEDERAL", value: OrgaoEmissaoCpfSNGPC.SRF },
    ];

    indicativoRegistroOptions: Array<Object> = [
        { text: "Cliente", value: "C" },
        { text: "Fornecedor", value: "F" },
        { text: "Ambos", value: "A" },
    ];

    beneficioFiscalOptions: Array<Object> = [
        { text: "Zona Franca de Manaus", value: BeneficioFiscal.ZonaFrancaManaus },
        { text: "Zona Franca", value: BeneficioFiscal.ZonaFranca },
        { text: "Área de Livre Comércio", value: BeneficioFiscal.AreaLivreComercio },
        { text: "Amazônia Ocidental", value: BeneficioFiscal.AmazoniaOcidental },
    ];

    indicativoPresencialConsumidorOptions: Array<Object> = [
        { text: "Não se aplica", value: IndicativoPresencialConsumidor.NaoSeAplica },
        { text: "Operação Presencial", value: IndicativoPresencialConsumidor.OperacaoPresencial },
        { text: "Operação não presencial, pela Internet", value: IndicativoPresencialConsumidor.OperacaoNaoPresencial },
        {
            text: "Operação não presencial, Teleatendimento",
            value: IndicativoPresencialConsumidor.OperacaoNaoPresencialTeleatendimento,
        },
        { text: "NFC", value: IndicativoPresencialConsumidor.NFC },
    ];

    freteClienteOptions: Array<Object> = [
        { text: "C - Por conta do emitente (PAGO)", value: "C" },
        { text: "F - Por conta do destinatário (A PAGAR)", value: "F" },
        { text: "T - Por conta de terceiros", value: "T" },
        { text: "X - Sem frete", value: "X" },
    ];

    tipoAcertoOptions: Array<Object> = [
        { text: "1 - Arredonda", value: 1 },
        { text: "2 - Trunca", value: 2 },
    ];

    codigoRegimeTributarioOptions: Array<Object> = [
        { text: "0 - Todos", value: 0 },
        { text: "1 - Simples Nacional", value: 1 },
        { text: "2 - Simples Nacional excesso de sublimite de receita bruta", value: 2 },
        { text: "3 - Regime Normal", value: 3 },
        { text: "4 - Simples Nacional - Microempreendedor Individual - MEI", value: 4 },
    ];

    naturezaRetencaoPisCofinsOptions: Array<Object> = [
        { text: "01 - Retenção por órgãos, autarquias e fundações federais", value: "01" },
        { text: "02 - Retenção por outras entidades da administração pública federal", value: "02" },
        { text: "03 - Retenção por pessoas jurídicas de direito privado", value: "03" },
        { text: "04 - Recolhimento por sociedade cooperativa", value: "04" },
        { text: "05 - Retenção por fabricante de máquinas e veículos", value: "05" },
        { text: "99 - Outras retenções", value: "99" },
    ];

    tipoDireitoPropriedadeOptions: Array<Object> = [
        { text: "1 - Privado", value: 1 },
        { text: "2 - Público", value: 2 },
    ];

    valorCalculoRetencaoOptions: Array<Object> = [
        { text: "P - Produto", value: "P" },
        { text: "E - Serviço", value: "E" },
        { text: "S - Ambos", value: "S" },
        { text: "N - Não Utiliza", value: "N" },
    ];

    cbsibsClienteOptions: Array<Object> = [
        { text: "1 - Tributada integral", value: 1 },
        { text: "2 - Não tributada", value: 2 },
    ];

    tipoEnteGovOptions: Array<Object> = [
        { text: "1 - União", value: 1 },
        { text: "2 - Estado", value: 2 },
        { text: "3 - DF", value: 3 },
        { text: "4 - Municipio", value: 4 },
    ];

    produtoUsoEspecialOptions: Array<Object> = [];
    produtoUsoEspecialId: number = null;

    gridColumnsEmails: Array<GridColumn> = [new GridColumn("email", "E-mail", GridColumnType.String)];
    gridColumnsTelefones: Array<GridColumn> = [
        new GridColumn("telefone", "Telefones", GridColumnType.String),
        new GridColumn("padrao", "Padrão", GridColumnType.Boolean),
    ];
    gridColumnsProdutosUsoEspecial: Array<GridColumn> = [
        new GridColumn("produtoDescricao", "Produtos de uso Especial", GridColumnType.String),
    ];

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("nome", "Nome", GridColumnType.String),
            new GridColumn("especieAnimalDescricao", "Esp\u00e9cie", GridColumnType.String),
            new GridColumn("generoDescricao", "G\u00eanero", GridColumnType.String),
            new GridColumn("peso", "Peso", GridColumnType.Decimal),
            new GridColumn("ativo", "Ativo", GridColumnType.Boolean),
        ];
    }

    gridColumnsEndereco: Array<GridColumn> = [
        new GridColumn("cep", "CEP", GridColumnType.String, false, false, "", "", true, false),
        new GridColumn("cidade", "Cidade", GridColumnType.String, false, false, "", "", true, false),
        new GridColumn("bairro", "Bairro", GridColumnType.String, false, false, "", "", true, false),
        new GridColumn("endereco", "Endere\u00e7o", GridColumnType.String, false, false, "", "", true, false),
    ];

    dadosCep: CepModel = new CepModel();
    ufOptions: Array<Object> = EnumExtensions.getNamesAndValuesOrderedByNames(Ufs);
    paisesOptions: Array<Object> = [];
    cidadesOptions: Array<Object> = [];
    beneficiosOptions: Array<Object> = [];
    naturezaOperacaoOptions: Array<Object> = [];
    modelEndereco: ClienteEnderecoEntregaModel = new ClienteEnderecoEntregaModel();

    private bloqueiaEdicaoSenior = false;

    private async beforeMount() {
        this.isGrupoAdmin = await this.HAS_PERMISSAO_PERFIL(false, false, false);
        await this.setProps(new ClienteService(), "clientes", new ClienteModel(), this.CalledByShortCut);

        const isAdmin = await this.HAS_PERMISSAO_PERFIL(false, false, false);
        const temPermissao = this.VALIDAR_PERMISSAO_USUARIO(DescricaoTela.clientes, AcaoController.seniorUpdate);
        this.bloqueiaEdicaoSenior = !isAdmin && !temPermissao;
    }

    public async load(customId = null) {
        while (!this.$refs.enderecoEntregaComponent) await Delay(5);
        this.enderecoEntregaComponent = this.$refs.enderecoEntregaComponent as EnderecoEntregaComponent;

        if (!this.isFranquiaHumana) {
            while (!this.$refs.pacienteComponent) await Delay(5);
            this.pacienteComponent = this.$refs.pacienteComponent as PacienteComponent;
        }

        this.enderecoEntregaComponent.clear();
        this.model = new ClienteModel();

        if (this.modelId > 0) {
            try {
                const data = await this.service.get(this.modelId).withLoading().resolveWithJSON<ClienteModel>();
                await this.onLoadCidades(data.estadoId);

                this.model.updateFrom(data);
                if (!this.isFranquiaHumana) {
                    this.model.pacientes.forEach(item => {
                        if (item.genero == null) {
                            item.generoDescricao = this.$t("__.ts.naoInfo").toString();
                        } else {
                            item.generoDescricao = item.genero
                                ? this.$t("__.ts.femea").toString()
                                : this.$t("__.ts.macho").toString();
                        }
                    });
                    this.pacienteComponent.carregarCliente(this.model.id);
                }
            } catch {
                this.$showError(this.$t("__.ts.erro"), this.$t("__.ts.erroCarregarDados"));
            }
        } else {
            this.model.tipoPessoa = TiposPessoa.Fisica;
        }
    }

    public async save() {
        try {
            if (await this.$validator.validateAll()) {
                if (
                    (this.emailNotaFiscalClienteObrigatorio || this.isEstereis) &&
                    this.model.emailsNotaFiscal?.length == 0
                ) {
                    this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.obrigatorioEmailNofaFiscal"));
                    return false;
                }
                if (this.isEstereis && this.model.telefones?.length == 0) {
                    this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.obrigatorioTelefone"));
                    return false;
                }
                if (this.model.cidadeId) {
                    if (this.cidadesOptions.length > 0) {
                        this.model.cidade = this.cidadesOptions.filter(item => item["value"] == this.model.cidadeId)[0][
                            "text"
                        ];
                    }
                }
                if (this.model.codigoPais != null) {
                    this.model.pais = this.paisesOptions.filter(item => item["value"] == this.model.codigoPais)[0][
                        "text"
                    ];
                }

                if (!this.model.cpf) {
                    this.model.cpf = null;
                }
                if (!this.model.cnpj) {
                    this.model.cnpj = null;
                }

                const response = await this.service[!this.model.id ? "insert" : "update"](this.model)
                    .withLoading()
                    .resolveWithResponse();

                const nId = Number(response.headers.get("Id"));

                if (response.ok) {
                    this.onSucessoSave(Number(response.headers.get("Id")));
                    await this.$showInclusaoUpdate(this.model.id);

                    if (this.CalledByShortCut) {
                        if (!this.model.id) {
                            this.model.id = nId;
                        }

                        this.$emit("save-ok", this.model);
                    } else {
                        this.$router.back();
                    }

                    return true;
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}

        return false;
    }

    private async onVerPaciente(paciente: PacienteModel) {
        try {
            while (!this.$refs.pacienteComponent) await Delay(5);
            this.pacienteComponent = this.$refs.pacienteComponent as PacienteComponent;

            this.pacienteComponent.loadWithModel(paciente);

            while (!this.$refs.shortcutComponent) await Delay(10);
            this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
            this.shortcutComponent.title = this.$t("__.ts.paciente").toString();
            this.oldPaciente = paciente;
        } catch {}

        this.shortcutComponent.show();
    }

    private async onCepChanged(data: CepModel) {
        this.dadosCep = data;
        this.model.bairro = data.bairro;
        this.model.complemento = data.complemento;
        this.model.endereco = data.endereco;
        this.model.estadoId = data.uf;
        await this.onLoadCidades(this.model.estadoId);
        this.model.cidadeId = data.cidadeId;
    }

    private replicarLocalizacao() {
        this.enderecoEntregaComponent.replicar(this.model);
    }

    private onCepInvalid() {
        this.$showInfo(this.$t("__.ts.pesqCEP"), this.$t("__.ts.pesqNaoEncResul"));
    }

    private onAddNewPaciente() {
        this.model.pacienteId = -1;
    }

    private onSavePaciente() {
        this.pacienteComponent.retornaPaciente();
        this.shortcutComponent.hide();
    }

    private async onAddPacienteOk(modelNovoPaciente: PacienteModel) {
        const alreadyExists = this.model.pacientes.some(p => p == this.oldPaciente);

        const paciente = new PacienteModel();

        try {
            const data = await especieAnimalService.get(modelNovoPaciente.especieAnimalId);

            modelNovoPaciente.especieAnimalDescricao = data.descricao;
            paciente.updateFrom(modelNovoPaciente);
            if (paciente.genero == null) {
                paciente.generoDescricao = this.$t("__.ts.naoInfo").toString();
            } else {
                paciente.generoDescricao = paciente.genero
                    ? this.$t("__.ts.femea").toString()
                    : this.$t("__.ts.macho").toString();
            }

            if (alreadyExists) {
                const index = this.model.pacientes.indexOf(this.oldPaciente);
                this.model.pacientes.splice(index, 1);
            }
            this.model.pacientes.push(paciente);

            this.pacienteComponent.clear();
            this.oldPaciente = null;
        } catch {}
    }

    private onAddEmail() {
        if (this.emailNotaFiscal) {
            try {
                const alreadyExists =
                    this.model.emailsNotaFiscal.filter(p => p.email == this.emailNotaFiscal).length > 0;

                if (!alreadyExists) {
                    const email = new ClienteEmailNotaFiscalModel();
                    email.email = this.emailNotaFiscal;
                    email.clienteId = this.model.id;

                    this.model.emailsNotaFiscal.push(email);
                    this.emailNotaFiscal = "";
                }
            } catch {}
        }
    }

    private onAddTelefone() {
        if (this.telefone) {
            try {
                if (this.telefonePadrao && this.model.telefones.some(p => p.padrao)) {
                    this.$showWarning(this.$t("__.ts.contato"), this.$t("__.ts.bloqueioTelefonePadraoDuplo"));
                    this.telefonePadrao = false;
                    return;
                }

                const alreadyExists = this.model.telefones.some(p => p.telefone == this.telefone);

                if (!alreadyExists) {
                    const telefone = new ClienteTelefoneModel();
                    telefone.telefone = this.telefone;
                    telefone.clienteId = this.model.id;
                    telefone.padrao = this.telefonePadrao;

                    this.model.telefones.push(telefone);
                    this.telefone = "";
                }

                this.telefonePadrao = false;
            } catch {}
        }
    }

    private onAddProdutosDeUsoEspecial() {
        if (this.produtoUsoEspecialId) {
            try {
                const alreadyExists =
                    this.model.produtosUsoEspecial.filter(p => p.produtoId == this.produtoUsoEspecialId).length > 0;

                if (!alreadyExists) {
                    const produtoUsoEspecial = new ClienteProdutoUsoEspecialModel();

                    produtoUsoEspecial.produtoId = this.produtoUsoEspecialId;
                    produtoUsoEspecial.produtoDescricao = this.produtoUsoEspecialOptions.getTextByValue(
                        this.produtoUsoEspecialId,
                    );
                    produtoUsoEspecial.clienteId = this.model.id;

                    this.model.produtosUsoEspecial.push(produtoUsoEspecial);
                    this.produtoUsoEspecialId = null;
                }
            } catch {}
        }
    }

    private onRemoverEmail(email: ClienteEmailNotaFiscalModel) {
        this.model.emailsNotaFiscal = this.model.emailsNotaFiscal.filter(p => p != email);
    }

    private onRemoverTelefone(telefone: ClienteTelefoneModel) {
        this.model.telefones = this.model.telefones.filter(p => p != telefone);
    }

    private onRemoveProdutoUsoEspecial(produtoUsoEspecial: ClienteProdutoUsoEspecialModel) {
        this.model.produtosUsoEspecial = this.model.produtosUsoEspecial.filter(p => p != produtoUsoEspecial);
    }

    private async onAdicionarEndereco(endereco: ClienteEnderecoEntregaModel) {
        if (endereco.cep != null && endereco.endereco != null) {
            const alreadyExists = this.model.enderecosEntrega.some(
                p =>
                    p.cidadeId == endereco.cidadeId &&
                    p.cep == endereco.cep &&
                    p.estadoId == endereco.estadoId &&
                    p.endereco == endereco.endereco &&
                    p.numero == endereco.numero,
            );

            if (!alreadyExists) {
                if (endereco.enderecoPadrao) this.atualizaEnderecoPadrao();

                this.model.enderecosEntrega.push(endereco);
                (this.$refs.enderecoEntregaComponent as EnderecoEntregaComponent).clear();
            } else {
                this.$showWarning(this.$t("__.ts.endeEntrega"), this.$t("__.ts.endeInfoJaCadast"));
            }
        } else {
            this.$showWarning(this.$t("__.ts.endeEntrega"), this.$t("__.ts.preenchCorretCamposAddLista"));
        }
    }

    private async onRemoveEndereco(endereco: ClienteEnderecoEntregaModel) {
        if (endereco.id != null) {
            try {
                await this.clienteEnderecoEntregaService.delete(endereco.id).withLoading();

                this.model.enderecosEntrega = this.model.enderecosEntrega.filter(p => p != endereco);
                this.$showSuccess("Sucesso", "Endereço de entrega excluído com sucesso");
            } catch (error) {
                this.$showError("Erro", "Não foi possível excluir o endereço de entrega");
            }
        } else {
            this.model.enderecosEntrega = this.model.enderecosEntrega.filter(p => p != endereco);
        }
    }

    private onEditEndereco(endereco: ClienteEnderecoEntregaModel) {
        this.enderecoEntregaComponent.clear();

        const index = this.model.enderecosEntrega.indexOf(endereco);
        this.modelEndereco = this.model.enderecosEntrega[index];
        const enderecoModel = new ClienteEnderecoEntregaModel();
        enderecoModel.updateFrom(endereco);

        this.enderecoEntregaComponent.load(enderecoModel);
    }

    private onEditEnderecoSubmit(endereco: ClienteEnderecoEntregaModel) {
        if (endereco.enderecoPadrao) {
            this.atualizaEnderecoPadrao();
        }

        const index = this.model.enderecosEntrega.indexOf(this.modelEndereco);
        copyObject(endereco, this.model.enderecosEntrega[index]);

        this.enderecoEntregaComponent.clear();
    }

    private atualizaEnderecoPadrao() {
        this.model.enderecosEntrega.forEach(value => {
            value.enderecoPadrao = false;
        });
    }

    private async onShowUploadAnexo() {
        this.uploadAnexoComponent = this.$refs.uploadAnexoComponent as UploadAnexoComponent;
        this.uploadAnexoComponent.show();
    }

    public async onSucessoSave(id?: number) {
        if (this.uploadAnexoComponent) {
            this.uploadAnexoComponent.onSucessoSave(id);
        }
    }

    @Watch("model.tipoPessoa")
    private onTipoPessoaChanged(tipoPessoa: TiposPessoa) {
        switch (tipoPessoa) {
            case TiposPessoa.Fisica:
                this.model.nomeFantasia = null;
                this.model.cnpj = null;
                this.model.inscricaoEstadual = null;
                this.model.inscricaoMunicipal = null;
                this.model.razaoSocial = null;
                break;
            case TiposPessoa.Juridica:
                this.model.nome = null;
                this.model.cpf = null;
                this.model.orgaoEmissaoCpfSNGPC = null;
                this.model.rg = null;
                this.model.dataNascimento = null;
                this.model.genero = null;
                this.model.orgaoExpedidor = null;
                this.model.ufExpedidor = null;
                break;
        }
    }

    private async onLoadCidades(estadoId: number) {
        try {
            this.cidadesOptions = [];
            if (estadoId) {
                this.cidadesOptions = await this.cidadeService.get(estadoId).withLoading();
            }
        } catch {}
    }

    private async loadNaturezaOperacao() {
        try {
            const data = await naturezaOperacaoService.comboCached(this.usuarioLogado.franquiaId);

            this.naturezaOperacaoOptions = data.sort((a, b) => (a["text"] > b["text"] ? 1 : -1));
        } catch {}
    }

    private onChangeEmail() {
        if (this.model.emailsNotaFiscal.length == 0) {
            this.emailNotaFiscal = this.model.email;
            this.onAddEmail();
        }
    }

    @Watch("model.nome")
    private onNomeChanged(newValue, oldValue) {
        try {
            if (this.pacienteComponent) {
                setTimeout(() => this.pacienteComponent.montarRotuloPeloCliente(newValue), 500);
            }

            const primeiroNomeNew = newValue.split(" ")[0];
            const primeiroNomeOld = oldValue.split(" ")[0];
            if (
                !this.model.nomeRotulo ||
                (this.rotuloCarregado &&
                    this.model.nomeRotulo &&
                    (primeiroNomeNew != primeiroNomeOld || (!primeiroNomeNew && primeiroNomeOld)))
            ) {
                this.model.nomeRotulo = primeiroNomeNew;
            }
            this.rotuloCarregado = true;
        } catch {}
    }

    private async onBlurCpf(cpfCliente: string) {
        try {
            if (cpfCliente) {
                const data = await this.clienteService.existsByCPF(cpfCliente).withLoading().resolveWithJSON<boolean>();

                if (data) {
                    this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.cpfExistente"));
                }
            }
        } catch {}
    }

    private async onBlurCnpj(cnpjCliente: string) {
        try {
            if (cnpjCliente) {
                const data = await this.clienteService
                    .existsByCNPJ(cnpjCliente)
                    .withLoading()
                    .resolveWithJSON<boolean>();

                if (data) {
                    this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.cnpjExistente"));
                }
            }
        } catch (err) {}
    }

    private loadPaises() {
        const paises = new PaisService().get();
        this.paisesOptions = paises.map(pais => ({ value: pais.codigoSPED, text: pais.descricao }));
    }

    private async loadBeneficios() {
        try {
            this.beneficiosOptions = await beneficioService.comboCached(this.usuarioLogado.franquiaId);
        } catch {}
    }

    public atualizarBeneficios() {
        this.loadBeneficios();
    }

    private async onOpenVendasModal() {
        while (!this.$refs.vendasClienteListComponent) await Delay(5);
        this.vendasClienteListComponent = this.$refs.vendasClienteListComponent as VendasClienteListComponent;
        this.vendasClienteListComponent.show(this.model.id, this.model.nome ?? this.model.razaoSocial);
    }

    private async onDelete() {
        try {
            const response = await this.$showQuestion(
                this.$t("__.ts.desejaExcl") + this.model.nome + "?",
                this.$t("__.ts.acaoNaoRevert"),
            );
            if (response) {
                const sucesso = await this.service.delete(this.model.id).withLoading();

                if (sucesso) {
                    await this.$showExclusao();
                    this.$router.back();
                }
            }
        } catch {}
    }

    private async print() {
        if (this.modelId > 0) {
            await this.pdfService.geraPDF(this.modelId);
        } else {
            this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.alertImpressao"));
        }
    }

    private async onShowInformacoesAdicionaisRepresentante() {
        while (!this.$refs.informacoesAdicionaisRepresentanteListComponent) await Delay(100);
        this.informacoesAdicionaisRepresentanteListComponent = this.$refs
            .informacoesAdicionaisRepresentanteListComponent as InformacoesAdicionaisRepresentanteListComponent;
        this.informacoesAdicionaisRepresentanteListComponent.show(this.model.id ?? 0, 1);
    }

    private validarVisibilidadeBotoes(botao: string) {
        if (botao == "replicar-filiais") {
            return (
                this.model.id > 0 &&
                this.usuarioLogado.franquia.isFranquiaMatrizOrFilial &&
                this.VALIDAR_PERMISSAO_USUARIO("franquias", "ReplicarItensFiliais")
            );
        }
    }

    private onReplicarFiliais() {
        this.replicarSelecaoFranquiaFiliaisComponent = this.$refs
            .replicarSelecaoFranquiaFiliaisComponent as ReplicarSelecaoFranquiaFiliaisComponent;
        this.replicarSelecaoFranquiaFiliaisComponent.openFranquias();
    }

    private async onConfirmReplicar(franquiasIds: Array<number>) {
        try {
            const sucesso = await this.clienteService
                .replicarCliente(this.model.id ?? 0, franquiasIds)
                .withLoading()
                .resolveWithoutJSON();
            if (sucesso) {
                this.$showSuccess("Replicou", this.$t("__.ts.regisSalvosSucess"));
            }
        } catch {}
    }

    public async afterMounted() {
        this.enderecoEntregaComponent = this.$refs.enderecoEntregaComponent as EnderecoEntregaComponent;
        this.isEstereis = await this.GET_IS_ESTEREIS();

        this.hideExtras = this.CalledByShortCut ? true : false;

        this.loadPaises();
        await this.loadBeneficios().withLoading();

        await this.loadNaturezaOperacao().withLoading();

        this.produtoUsoEspecialOptions = await produtoService.comboCached(this.usuarioLogado.franquiaId ?? 0);

        if (this.CalledByShortCut) {
            this.model = new ClienteModel();
        }

        if (this.isEstereis) {
            this.model.codRepresentantePadrao = this.model.codRepresentantePadrao
                ? this.model.codRepresentantePadrao
                : 1;
            this.model.valorCalculoRetencao = this.model.valorCalculoRetencao ?? "S";
        }

        if (this.usuarioLogado.franquia.areaAtuacao === AreaAtuacao.Humana) {
            this.isFranquiaHumana = true;
            if (this.modelId == 0) {
                this.model.pacienteCliente = true;
            }
        }

        this.somenteConsulta = this.VALIDAR_PERMISSAO_SOMENTE_CONSULTA("clientes");
        this.cpfObrigatorio = this.GET_CONFIG_FRANQUIA(Configuracoes.CpfClienteObrigatorio)?.verdadeiro ?? false;
        this.emailNotaFiscalClienteObrigatorio =
            this.GET_CONFIG_FRANQUIA(Configuracoes.EmailNotaFiscalClienteObrigatorio)?.verdadeiro ?? false;
    }
}
